import { createActions } from 'redux-actions';

import { ENDPOINTS_USER } from '../../config/';
import { CompetitionAPIBase } from '../../reducers/DashboardReducer/CompetitionsReducer/CompetitionsReducer.types';
import { defaultErrorMessage, globalFetch, isAction } from '../../shared/helpers/fetch-helper';
import { logErrorService } from '../../shared/services';

export const { dashboardCompetitionsResponse, dashboardCompetitionsRequest, dashboardCompetitionsResponseFailure } = createActions(
  {
    DASHBOARD_COMPETITIONS_RESPONSE: (data: CompetitionAPIBase) => ({ data }),
  },
  'DASHBOARD_COMPETITIONS_REQUEST',
  'DASHBOARD_COMPETITIONS_RESPONSE_FAILURE'
);

export function getDashboardCompetitions() {
  return async (dispatch: any, getState: any): Promise<object> => {
    const state = getState();
    if (state.getIn(['dashboard', 'competitions', 'isfetching']) === true) {
      return dispatch(dashboardCompetitionsRequest());
    }

    dispatch(dashboardCompetitionsRequest());

    return globalFetch(
      `${ENDPOINTS_USER.user}/self/competitions`,
      {
        method: 'GET',
        credentials: 'include',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      },
      dispatch,
      () => dispatch(dashboardCompetitionsResponseFailure())
    )
      .then(async (json: any): Promise<object> => {
        if (isAction(json, 'DASHBOARD_COMPETITIONS_RESPONSE_FAILURE')) {
          return json;
        } else {
          return dispatch(dashboardCompetitionsResponse(json));
        }
      })
      .catch((err: any) => {
        logErrorService(err, err);
        defaultErrorMessage(dispatch);

        return dispatch(dashboardCompetitionsResponseFailure());
      });
  };
}
